import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function SimpleStorageENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple Storage Service")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Creating an S3 Bucket</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">A bucket is a container that stores objects in Amazon S3. </p>
                                <p class="typo-14">It is the top-level directory accessed via a URL.</p>
                            </BoxText>
                            <br></br>
                            <BoxText  >
                                <p class="typo-14">- Bucket Name:  </p>
                                <p class="typo-14">- Region &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </p>
                                <p class="typo-14">- Access Control  :</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>File Upload / Download URL:</p></BoxTitle>

                            <BoxText  >
                                https://
                                <font color="red">BucketName</font>.storage.
                                <font color="red">Region</font>.vora.net/
                                <font color="red">Directory Name</font>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Object Storage S3 - Object Upload Architecture</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">Before uploading objects (files, metadata) to an S3 bucket, request a Pre-signed URL from the storage API, and upload directly to the received Pre-signed URL.</p>
                            </BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-1.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-1.svg"></ImageWrap>

                            <BoxText  >
                                <p class="typo-14"><b>Single request upload</b></p>
                                <p class="typo-14">- Upload a file of approximately 30MB in a single request.</p>
                                <br></br>
                                <p class="typo-14"><b>Multipart upload</b></p>
                                <p class="typo-14">- Split the file into at least 3 parts and upload them in parallel.</p>
                                <p class="typo-14">- To reduce total time, each split part is uploaded in parallel.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Object Storage - Download Architecture</p></BoxTitle>

                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-2.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-2.svg"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Managing objects within the bucket through the web</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- Object refers to the files and metadata stored in storage.</p>
                                <p class="typo-14">- To manage the objects in the bucket, retrieve the list of objects in the bucket and perform operations based on the permissions set in the IAM's ACL (Access Control List).</p>
                            </BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-3.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-3.svg"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>IAM Object Resource Registration for Permission Granting:</p></BoxTitle>

                            <BoxText  ><p class="typo-14">- Hierarchy (Parent / Child):</p></BoxText>
                            <BoxText  >
                                <p class="typo-14">- The child objects (directories/objects) inherit permissions from the parent by default, with separate permission settings for individual child objects if needed.</p>
                            </BoxText>
                            <BoxText  ><p class="typo-14">- Permissions: Read / Write / Delete</p></BoxText>
                            <BoxText  ><p class="typo-14">• Bucket</p></BoxText>
                            <BoxSubText  ><p class="typo-14">• Directory</p></BoxSubText>
                            <BoxSubTextSub  ><p class="typo-14">• Object(File, Metadata)</p></BoxSubTextSub>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class='typo-21 typo-medium typo-black'>Traditional Server - File Upload / Download Architecture:</p></BoxTitle>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-4.svg")} */}
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-storage-service/simple-storage-service-4.svg"></ImageWrap>
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};


const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxSubText = styled.div`
  margin-left: 3%;
  line-height: 2em;
  
`
const BoxSubTextSub = styled.div`
  margin-left: 6%;
  line-height: 2em;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default SimpleStorageENG;